<div *ngIf="crumbs$ | async as breadcrumbs" class="breadcrumbs">
  <ng-container *ngFor="let breadcrumb of breadcrumbs; last as isLast">
    <a *ngIf="!isLast" class="breadcrumb-item" [routerLink]="[breadcrumb.path]">{{ breadcrumb.label }}</a>
    <mat-icon *ngIf="!isLast" class="breadcrumb-separator">chevron_right</mat-icon>
    <span *ngIf="isLast" class="breadcrumb-item active">{{ breadcrumb.label }}</span>
  </ng-container>
</div>
